import React, { useState } from 'react';
import '../css/App.css';
import API_BASE from './apiBase';
// const DSARForm = () => {
const DSARForm = ({ showEmbed = true }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    formerNames: '',
    currentAddress: '',
    formerAddress: '',
    dateOfBirth: '',
    email: '',
    contactPhone: '',
    isDataSubject: '',
    dsFullName: '',
    dsFormerNames: '',
    dsCurrentAddress: '',
    dsFormerAddress: '',
    dsDateOfBirth: '',
    dsEmail: '',
    dsContactPhone: '',
    requestType: [],
    personalDataInvolved: '',
    requestDetails: '',
    requestReason: '',
    previousDSARDate: '',
    previousDSARReference: '',
    previousDSARName: '',
    declarationSignature: '',
    declarationName: '',
    declarationDate: ''
  });

  const [currentSection, setCurrentSection] = useState(1);
  const [sectionErrors, setSectionErrors] = useState({});
  const today = new Date().toISOString().split('T')[0];

  // Validation helpers used for per-section gating
  const isValidEmail = (s) => !!(s && /^\S+@\S+\.\S+$/.test(s));
  const isValidPhone = (s) => {
    if (!s) return false;
    const digits = s.replace(/\D/g, '');
    return digits.length === 10 && /^[6789]\d{9}$/.test(digits);
  };
  const isNotFutureDate = (dateStr) => {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    const t = new Date();
    d.setHours(0, 0, 0, 0);
    t.setHours(0, 0, 0, 0);
    return d <= t;
  };

  const canProceed = (section) => {
    switch (section) {
      case 1:
        return (
          formData.fullName && formData.fullName.trim() &&
          formData.currentAddress && formData.currentAddress.trim() &&
          isValidEmail(formData.email) &&
          isValidPhone(formData.contactPhone) &&
          isNotFutureDate(formData.dateOfBirth)
        );
      case 2:
        if (!formData.isDataSubject) return false;
        if (formData.isDataSubject === 'no') {
          return (
            formData.dsFullName && formData.dsFullName.trim() &&
            formData.dsCurrentAddress && formData.dsCurrentAddress.trim() &&
            isValidEmail(formData.dsEmail) &&
            isValidPhone(formData.dsContactPhone) &&
            isNotFutureDate(formData.dsDateOfBirth)
          );
        }
        return true;
      case 3:
        return (
          Array.isArray(formData.requestType) && formData.requestType.length > 0 &&
          formData.personalDataInvolved && formData.personalDataInvolved.trim() &&
          formData.requestDetails && formData.requestDetails.trim() &&
          formData.requestReason && formData.requestReason.trim()
        );
      case 4:
        return (
          formData.declarationSignature && formData.declarationSignature.trim() &&
          formData.declarationName && formData.declarationName.trim() &&
          formData.declarationDate && isNotFutureDate(formData.declarationDate)
        );
      default:
        return true;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // clear current section error when user edits
    setSectionErrors(prev => { const c = { ...prev }; delete c[currentSection]; return c; });
  };

  const validateField = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    // phone validation
    if (name === 'contactPhone' || name === 'dsContactPhone') {
      const digits = (value || '').replace(/\D/g, '');
      if (digits.length !== 10 || !/^[6789]/.test(digits)) {
        setSectionErrors(prev => ({ ...prev, [currentSection]: 'Mobile number not correct: must be 10 digits and start with 6, 7, 8 or 9.' }));
        return false;
      }
      setSectionErrors(prev => { const c = { ...prev }; delete c[currentSection]; return c; });
      return true;
    }

    // email validation
    if (name === 'email' || name === 'dsEmail') {
      const ok = !!(value && /^\S+@\S+\.\S+$/.test(value));
      if (!ok) {
        setSectionErrors(prev => ({ ...prev, [currentSection]: 'Please enter a valid email address.' }));
        return false;
      }
      setSectionErrors(prev => { const c = { ...prev }; delete c[currentSection]; return c; });
      return true;
    }

    // default: clear
    setSectionErrors(prev => { const c = { ...prev }; delete c[currentSection]; return c; });
    return true;
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      requestType: checked
        ? [...prev.requestType, value]
        : prev.requestType.filter(type => type !== value)
    }));
    setSectionErrors(prev => { const c = { ...prev }; delete c[currentSection]; return c; });
  };

  const handleRadioChange = (e) => {
    setFormData(prev => ({ ...prev, isDataSubject: e.target.value }));
    setSectionErrors(prev => { const c = { ...prev }; delete c[currentSection]; return c; });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Client-side validation
    const isValidEmail = (s) => !!(s && /^\S+@\S+\.\S+$/.test(s));
    const isValidPhone = (s) => {
      if (!s) return false;
      const digits = s.replace(/\D/g, '');
      // require exactly 10 digits and first digit not 1-6 (require 7/8/9)
      return digits.length === 10 && /^[6789]\d{9}$/.test(digits);
    };
    const isNotFutureDate = (dateStr) => {
      if (!dateStr) return false;
      const d = new Date(dateStr);
      const today = new Date();
      // zero time part for comparison
      d.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return d <= today;
    };

    // Validate primary email/phone/dob
    const errors = [];
    if (!isValidEmail(formData.email)) errors.push('Please enter a valid email address.');
    if (!isValidPhone(formData.contactPhone)) errors.push('Phone must be 10 digits and start with 6, 7, 8, or 9.');
    if (!isNotFutureDate(formData.dateOfBirth)) errors.push('Date of Birth cannot be in the future.');

    // If acting on behalf (not data subject), validate data-subject fields
    if (formData.isDataSubject === 'no') {
      if (formData.dsEmail && !isValidEmail(formData.dsEmail)) errors.push('Please enter a valid data-subject email.');
      if (formData.dsContactPhone && !isValidPhone(formData.dsContactPhone)) errors.push('Data-subject phone must be 10 digits and start with 6, 7, 8, or 9.');
      if (formData.dsDateOfBirth && !isNotFutureDate(formData.dsDateOfBirth)) errors.push('Data-subject Date of Birth cannot be in the future.');
    }

    if (errors.length) {
      // Map errors to sections so we can show a popup on the offending section
      // section 1: primary contact fields; section 2: data-subject; section 3: request details; section 4: declaration
      const mapping = {};
      errors.forEach(err => {
        if (err.toLowerCase().includes('email') || err.toLowerCase().includes('phone') || err.toLowerCase().includes('date of birth') || err.toLowerCase().includes('full name') || err.toLowerCase().includes('address')) {
          mapping[1] = mapping[1] ? mapping[1] + '\n' + err : err;
        } else if (err.toLowerCase().includes('data-subject')) {
          mapping[2] = mapping[2] ? mapping[2] + '\n' + err : err;
        } else if (err.toLowerCase().includes('request')) {
          mapping[3] = mapping[3] ? mapping[3] + '\n' + err : err;
        } else {
          mapping[1] = mapping[1] ? mapping[1] + '\n' + err : err;
        }
      });
      setSectionErrors(mapping);
      // navigate to first section that has an error
      const firstErrSection = Math.min(...Object.keys(mapping).map(k => Number(k)));
      setCurrentSection(firstErrSection);
      return;
    }

    (async () => {
      try {
        const payload = { ...formData };
        if (!Array.isArray(payload.requestType)) {
          payload.requestType = payload.requestType ? [payload.requestType] : [];
        }
        const extraHeaders = {};
        try {
          if (process.env.REACT_APP_MANAGER_API_KEY) extraHeaders['X-API-KEY'] = process.env.REACT_APP_MANAGER_API_KEY;
          if (process.env.REACT_APP_MANAGER_API_TOKEN) extraHeaders['X-API-TOKEN'] = process.env.REACT_APP_MANAGER_API_TOKEN;
        } catch (e) { }
        const res = await fetch(`${API_BASE}/manager/dsar`, {
          method: 'POST',
          headers: Object.assign({ 'Content-Type': 'application/json' }, extraHeaders),
          body: JSON.stringify(payload)
        });
        if (!res.ok) {
          const txt = await res.text();
          throw new Error(txt || 'Server error');
        }
        // const body= await res.json();
        // console.log('DSAR submit response', body);
        // alert(' form submitted successfully');
        // try { window.dispatchEvent(new CustomEvent('dsarSubmitted', { detail: body })); } catch (e) {}
        // handleReset();
        await res.json();
        alert('Your request was successfully submitted. We will process it as soon as possible.');
        handleReset();
      } catch (err) {
        console.error('DSAR submit error', err);
        alert('Submit failed: ' + (err.message || String(err)));
      }
    })();
  };

  const handleReset = () => {
    if (window.confirm('Are you sure you want to reset the form? All data will be lost.')) {
      setFormData({
        fullName: '', formerNames: '', currentAddress: '', formerAddress: '',
        dateOfBirth: '', email: '', contactPhone: '', isDataSubject: '',
        dsFullName: '', dsFormerNames: '', dsCurrentAddress: '', dsFormerAddress: '',
        dsDateOfBirth: '', dsEmail: '', dsContactPhone: '', requestType: [],
        personalDataInvolved: '', requestDetails: '', requestReason: '',
        previousDSARDate: '', previousDSARReference: '', previousDSARName: '',
        declarationSignature: '', declarationName: '', declarationDate: ''
      });
      setCurrentSection(1);
    }
  };
  //   const embedSnippet=`<script src="${window.location.origin}/widget/dsar-widget.js" data-api-base="${window.location.origin}" data-tenant="your-tenant"></script>`;
  // Embed host: prefer explicit REACT_APP_EMBED_HOST, otherwise show a placeholder
  const EMBED_HOST = (process.env.REACT_APP_EMBED_HOST && process.env.REACT_APP_EMBED_HOST.trim()) || 'https://your-domain.com';
  const embedHostClean = EMBED_HOST.replace(/\/$/, '');
  const embedSnippet = `<script src="${embedHostClean}/widget/dsar-widget.js" data-api-base="${embedHostClean}" data-tenant="your-tenant"></script>`;

  const copyEmbed = async () => {
    try {
      await navigator.clipboard.writeText(embedSnippet);
      alert('✓ Embed snippet copied to clipboard');
    } catch (err) {
      alert('Copy failed');
    }
  };

  const sections = [
    { id: 1, title: 'Personal Information', icon: '👤' },
    { id: 2, title: 'Data Subject Status', icon: '🔐' },
    { id: 3, title: 'Request Details', icon: '📋' },
    { id: 4, title: 'Declaration', icon: '✍️' }
  ];

  // Responsive form card style
  const formContainerStyle = {
    width: '100%',
    maxWidth: '540px',
    minWidth: '0',
    margin: '0 auto',
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
    padding: '5vw 4vw',
    boxSizing: 'border-box',
  };

  return (
    <div className="dsar-container">
      {/* Header */}
      <div className="dsar-header">
        <div className="header-content">
          <div className="header-icon">🛡️</div>
          <div className="header-title">
            <h1> DSAR Form Data Request</h1>
            {/* <p className="header-subtitle">Whitehats.in</p> */}
          </div>
        </div>

        {/* Progress Steps */}
        <div className="progress-steps">
          {sections.map((section) => (
            <div
              key={section.id}
              className={`step-item ${currentSection === section.id ? 'active' : ''}`}
              onClick={() => setCurrentSection(section.id)}
            >
              <span className="step-icon">{section.icon}</span>
              <div className="step-title">{section.title}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="form-layout">
        {/* Main Form */}
        <div className="form-card">
          <form onSubmit={handleSubmit}>
            {/* Section 1: Personal Information */}
            {currentSection === 1 && (
              <div>
                <div className="section-header">
                  <div className="section-icon">👤</div>
                  <div className="section-title">
                    <h2>Personal Information</h2>
                    <p className="section-subtitle">Tell us about yourself</p>
                  </div>
                </div>

                <div className="input-grid-2">
                  <div className="form-group">
                    <label className="form-label">
                      Full Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      required
                      className="form-input"
                      placeholder="John Doe"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Former Names</label>
                    <input
                      type="text"
                      name="formerNames"
                      value={formData.formerNames}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Previous name(s)"
                    />
                  </div>
                </div>
                <div className="input-grid-2">
                  <div className="form-group">
                    <label className="form-label">
                      Current Address <span className="required">*</span>
                    </label>
                    <textarea
                      name="currentAddress"
                      value={formData.currentAddress}
                      onChange={handleInputChange}
                      required
                      className="form-textarea"
                      placeholder="Street, City, Postal Code, Country"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Former Address</label>
                    <textarea
                      name="formerAddress"
                      value={formData.formerAddress}
                      onChange={handleInputChange}
                      className="form-textarea"
                      placeholder="Include dates of change if applicable"
                    />
                  </div>
                </div>

                <div className="input-grid-3">
                  <div className="form-group">
                    <label className="form-label">
                      Date of Birth <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleInputChange}
                      required
                      className="form-input"
                      max={today}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="form-input"
                      placeholder="you@example.com"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Phone <span className="required">*</span>
                    </label>
                    <input
                      type="tel"
                      name="contactPhone"
                      value={formData.contactPhone}
                      onChange={handleInputChange}
                      onBlur={validateField}
                      required
                      className="form-input"
                      placeholder="+91 654 789 1230"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Section 2: Data Subject Status */}
            {currentSection === 2 && (
              <div>
                <div className="section-header">
                  <div className="section-icon">🔐</div>
                  <div className="section-title">
                    <h2>Data Subject Status</h2>
                    <p className="section-subtitle">Confirm your identity</p>
                  </div>
                </div>

                <div className="radio-group">
                  <label className={`radio-option ${formData.isDataSubject === 'yes' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="isDataSubject"
                      value="yes"
                      checked={formData.isDataSubject === 'yes'}
                      onChange={handleRadioChange}
                    />
                    <div className="option-label">
                      <div className="option-title">✓ I am the Data Subject</div>
                      <div className="option-description">
                        I enclose evidence of my identity and address
                      </div>
                    </div>
                  </label>

                  <label className={`radio-option ${formData.isDataSubject === 'no' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="isDataSubject"
                      value="no"
                      checked={formData.isDataSubject === 'no'}
                      onChange={handleRadioChange}
                    />
                    <div className="option-label">
                      <div className="option-title">✓ I am a Personal Representative</div>
                      <div className="option-description">
                        Acting on behalf of the Data Subject with written authority
                      </div>
                    </div>
                  </label>
                </div>

                <div className="alert alert-warning">
                  <div className="alert-icon">⚠️</div>
                  <div className="alert-content">
                    <div className="alert-title">Identity Verification Required</div>
                    <div className="alert-text">
                      Please provide at least two forms of identification to authenticate your identity and physical address.
                      Documents should be transmitted through secure means. We reserve the right to decline requests without adequate proof.
                    </div>
                  </div>
                </div>

                {formData.isDataSubject === 'no' && (
                  <div className="data-subject-box">
                    <h3>Data Subject Details</h3>

                    <div className="input-grid-2">
                      <div className="form-group">
                        <label className="form-label">Full Name <span className="required">*</span></label>
                        <input
                          type="text"
                          name="dsFullName"
                          value={formData.dsFullName}
                          onChange={handleInputChange}
                          required={formData.isDataSubject === 'no'}
                          className="form-input"
                          placeholder="Data subject's full name"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Former Names</label>
                        <input
                          type="text"
                          name="dsFormerNames"
                          value={formData.dsFormerNames}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Current Address <span className="required">*</span></label>
                      <textarea
                        name="dsCurrentAddress"
                        value={formData.dsCurrentAddress}
                        onChange={handleInputChange}
                        required={formData.isDataSubject === 'no'}
                        className="form-textarea"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Former Address</label>
                      <textarea
                        name="dsFormerAddress"
                        value={formData.dsFormerAddress}
                        onChange={handleInputChange}
                        className="form-textarea"
                      />
                    </div>

                    <div className="input-grid-3">
                      <div className="form-group">
                        <label className="form-label">Date of Birth <span className="required">*</span></label>
                        <input
                          type="date"
                          name="dsDateOfBirth"
                          value={formData.dsDateOfBirth}
                          onChange={handleInputChange}
                          required={formData.isDataSubject === 'no'}
                          className="form-input"
                          max={today}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Email <span className="required">*</span></label>
                        <input
                          type="email"
                          name="dsEmail"
                          value={formData.dsEmail}
                          onChange={handleInputChange}
                          required={formData.isDataSubject === 'no'}
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Phone <span className="required">*</span></label>
                        <input
                          type="tel"
                          name="dsContactPhone"
                          value={formData.dsContactPhone}
                          onChange={handleInputChange}
                          onBlur={validateField}
                          required={formData.isDataSubject === 'no'}
                          className="form-input"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Section 3: Request Details */}
            {currentSection === 3 && (
              <div>
                <div className="section-header">
                  <div className="section-icon">📋</div>
                  <div className="section-title">
                    <h2>Request Details</h2>
                    <p className="section-subtitle">Specify your DSAR rights</p>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">
                    Request Type <span className="required">*</span>
                  </label>
                  <div className="checkbox-group">
                    {[
                      { label: 'Consent Withdrawal', icon: '🚫' },
                      { label: 'Access request', icon: '🔍' },
                      { label: 'Rectification of personal data', icon: '✏️' },
                      { label: 'Erasure of personal data', icon: '🗑️' },
                      { label: 'Restriction of processing', icon: '⏸️' },
                      { label: 'Data portability request', icon: '📦' },
                      { label: 'Objection to processing', icon: '✋' },
                      { label: 'Automated decision making', icon: '🤖' }
                    ].map((option, idx) => (
                      <label
                        key={idx}
                        className={`checkbox-option ${formData.requestType.includes(option.label) ? 'selected' : ''}`}
                      >
                        <input
                          type="checkbox"
                          value={option.label}
                          checked={formData.requestType.includes(option.label)}
                          onChange={handleCheckboxChange}
                        />

                        <div className="option-label">
                          <span style={{ fontSize: '16px', marginRight: '10px' }}>{option.icon}</span>
                          <span className="option-title">{option.label}</span>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">
                    Personal Data Involved <span className="required">*</span>
                  </label>
                  <textarea
                    name="personalDataInvolved"
                    value={formData.personalDataInvolved}
                    onChange={handleInputChange}
                    required
                    className="form-textarea"
                    placeholder="Describe the personal data involved in your request..."
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    Request Details <span className="required">*</span>
                  </label>
                  <textarea
                    name="requestDetails"
                    value={formData.requestDetails}
                    onChange={handleInputChange}
                    required
                    className="form-textarea"
                    placeholder="Provide detailed information about your request..."
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    Request Reason <span className="required">*</span>
                  </label>
                  <textarea
                    name="requestReason"
                    value={formData.requestReason}
                    onChange={handleInputChange}
                    required
                    className="form-textarea"
                    placeholder="Explain the reason for your request..."
                  />
                </div>

                <div className="alert alert-info">
                  <div className="alert-icon">ℹ️</div>
                  <div className="alert-content">
                    <div className="alert-text">
                      <strong>Important:</strong> If your request reveals details about another person, we need their consent.
                      Information covered by legal professional privilege cannot be disclosed.
                    </div>
                  </div>
                </div>

                <div className="data-subject-box" style={{ marginTop: '30px' }}>
                  <h3>Previous DSAR (Optional)</h3>
                  <div className="input-grid-2">
                    <div className="form-group">
                      <label className="form-label">Date of Previous DSAR</label>
                      <input
                        type="date"
                        name="previousDSARDate"
                        value={formData.previousDSARDate}
                        onChange={handleInputChange}
                        className="form-input"
                        max={today}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Reference Number</label>
                      <input
                        type="text"
                        name="previousDSARReference"
                        value={formData.previousDSARReference}
                        onChange={handleInputChange}
                        className="form-input"
                        placeholder="e.g., DSAR-2024-001"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Name DSAR Was Made Under</label>
                    <input
                      type="text"
                      name="previousDSARName"
                      value={formData.previousDSARName}
                      onChange={handleInputChange}
                      className="form-input"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Section 4: Declaration */}
            {currentSection === 4 && (
              <div>
                <div className="section-header">
                  <div className="section-icon">✍️</div>
                  <div className="section-title">
                    <h2>Declaration</h2>
                    <p className="section-subtitle">Confirm and submit</p>
                  </div>
                </div>

                <div className="alert alert-warning">
                  <div className="alert-icon">📜</div>
                  <div className="alert-content">
                    <div className="alert-title">Legal Declaration</div>
                    <div className="alert-text">
                      I declare that the information given above is correct to the best of my knowledge,
                      and that I am entitled to make the request identified above under the terms of the GDPR.
                    </div>
                  </div>
                </div>

                <div className="input-grid-3">
                  <div className="form-group">
                    <label className="form-label">
                      Digital Signature <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="declarationSignature"
                      value={formData.declarationSignature}
                      onChange={handleInputChange}
                      required
                      placeholder="Type your full name"
                      className="form-input signature-input"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Full Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="declarationName"
                      value={formData.declarationName}
                      onChange={handleInputChange}
                      required
                      className="form-input"
                    />
                  </div>


                  <div className="form-group">
                    <label className="form-label">
                      Date of Request <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="declarationDate"
                      value={formData.declarationDate}
                      onChange={handleInputChange}
                      required
                      className="form-input"
                      style={{ maxWidth: '300px' }}
                      max={today}
                    />
                  </div>
                </div>

                <div className="alert alert-success">
                  <div className="alert-icon">📮</div>
                  <div className="alert-content">
                    <div className="alert-title">Submission Information</div>
                    <div className="alert-text" style={{ marginBottom: '15px' }}>
                      Once completed, submit this form via:
                    </div>
                    <div className="contact-cards-wrapper">
                      <div className="contact-card">
                        <div className="contact-icon">✉️</div>
                        <div>
                          <div className="contact-label">Email</div>
                          <div className="contact-value">support@whitehats.in</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Navigation Buttons */}
            {/* Per-section inline error popup */}
            {sectionErrors[currentSection] && (
              <div className="section-error-popup" style={{ background: '#fff3f3', border: '1px solid #f5c2c7', padding: 12, borderRadius: 8, marginBottom: 12, color: '#7a1f1f' }}>
                <strong style={{ display: 'block', marginBottom: 6 }}>Please fix the following:</strong>
                <div style={{ whiteSpace: 'pre-wrap', fontSize: 14 }}>{sectionErrors[currentSection]}</div>
              </div>
            )}
            <div className="form-actions">
              <button
                type="button"
                onClick={() => currentSection > 1 && setCurrentSection(currentSection - 1)}
                disabled={currentSection === 1}
                className="btn btn-secondary"
                style={{ backgroundColor: '#6c757d', color: '#fff', border: 'none' }}
              >
                ← Previous
              </button>

              <div className="action-right">
                <button type="button" onClick={handleReset} className="btn btn-danger" style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none' }}>
                  🔄 Reset
                </button>

                {currentSection < 4 ? (
                  <button
                    type="button"
                    onClick={() => {
                      if (canProceed(currentSection)) {
                        // clear any existing error for this section
                        setSectionErrors(prev => { const c = { ...prev }; delete c[currentSection]; return c; });
                        setCurrentSection(currentSection + 1);
                      } else {
                        // Build a helpful message for this section
                        let msg = '';
                        switch (currentSection) {
                          case 1:
                            msg = 'Please ensure Full name, Current address, valid Email, valid Phone and Date of Birth are provided.';
                            break;
                          case 2:
                            msg = 'Please complete data-subject details (name, address, email, phone, DOB) if acting on behalf.';
                            break;
                          case 3:
                            msg = 'Please select at least one request type and fill Personal Data Involved, Request Details and Request Reason.';
                            break;
                          default:
                            msg = 'Please complete required fields before proceeding.';
                        }
                        setSectionErrors(prev => ({ ...prev, [currentSection]: msg }));
                      }
                    }}
                    className="btn btn-primary"
                    disabled={!canProceed(currentSection)}
                    style={{ backgroundColor: '#2563eb', color: '#fff', border: 'none' }}
                  >
                    Next →
                  </button>
                ) : (
                  <button type="submit" className="btn btn-success" style={{ backgroundColor: '#28a745', color: '#fff', border: 'none' }}>
                    ✓ Submit Request
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DSARForm;